module.exports = __webpack_public_path__ + "img/answer-language-local.f642e8c6.png";